/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconPhotoMinus = createReactComponent("photo-minus", "IconPhotoMinus", [
  ["path", { d: "M15 8h.01", key: "svg-0" }],
  [
    "path",
    {
      d: "M12.5 21h-6.5a3 3 0 0 1 -3 -3v-12a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v9",
      key: "svg-1"
    }
  ],
  ["path", { d: "M3 16l5 -5c.928 -.893 2.072 -.893 3 0l4 4", key: "svg-2" }],
  ["path", { d: "M14 14l1 -1c.928 -.893 2.072 -.893 3 0l2 2", key: "svg-3" }],
  ["path", { d: "M16 19h6", key: "svg-4" }]
]);

export { IconPhotoMinus as default };
//# sourceMappingURL=IconPhotoMinus.js.map
